import {BaseMuWidget} from "./BaseMuWidget";
import {MuNamedWidgets} from "mu-widget/lib/MuWidget";
import {DateRepeating} from "./components/DateRepeating";
import {AttachList} from "./AttachList";
import {MultiUpload} from "./MultiUpload";
import {TicketsCL} from "./generated/TicketsCL";
import {CalCL} from "./generated/CalCL";
import {CalItemRepeating, TodoTicketItem} from "./CommonTypes";
import {ErrorMarker, ErrorMarkerErrors} from "./ErrorMarker";
import {flashError, flashInfo} from "./Utils";
import {BaseRouter} from "./BaseRouter";
import {Ticket} from "./TicketTypes";

export class TodoTicketForm extends BaseMuWidget {

    // @ts-ignore
    muNamedWidget: MuNamedWidgets<{
        repeating: DateRepeating,
        attachList: AttachList,
        attachNew: MultiUpload,
    }>;

    ticketsCl = new TicketsCL();
    calCl = new CalCL();
    public uploadUrl: string = "/ticket/upload-raw-attach";

    public addTitle: boolean = false;

    protected itemType: "cir"|"ticket"|"new" = "new";
    private item: null|CalItemRepeating|TodoTicketItem = null;
    private errorMarker: ErrorMarker = new ErrorMarker(this);

    doNew() {
        this.item = null;
        this.itemType = "new";
        this.muNamedWidget.repeating.type = null;
        this.muNamedWidget.repeating.update();
    }

    async doLoad(id: number, itemType: "cir"|"ticket"): Promise<Ticket|CalItemRepeating> {
        this.itemType = itemType;
        this.item = itemType === "ticket"
            ? await this.ticketsCl.withMessage("Načítám položku", this.ui.editor).getTodoTicket(id)
            : await this.ticketsCl.withMessage("Načítám řadu", this.ui.editor).getCalItemRepeating(id);
        this.muBindData(this.item);
        if (itemType === "cir") this.muBindData({ repeating: this.item });
        this.updateForm();
        if (itemType === "ticket") {
            await this.muNamedWidget.attachList.bindData({
                ticketId: id
            });
        }

        // @ts-ignore
        return this.item;
    }

    beforeIndex() {
        this.muRegisterEvent('saved');
        this.muAppendContent(
            (this.addTitle ? '<h1 mu="modalTitle"></h1>' : '')
            + `<div mu="editor">
                <div class="row form-group">
                    <label class="col-3 control-label" mu-for="name">Název</label>
                    <div class="col-9 form-label">
                        <input type="text" mu-bind="name" class="form-control" />
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-3 control-label" mu-for="summary">Poznámka</label>
                    <div class="col-9 form-label">
                        <div mu="note:Htmlarea#note"></div>
                    </div>
                </div>
                <div mu="repeating:DateRepeating#repeating"></div>
                <div mu="repeatingInfo"></div>
                <div class="row form-group control-label" mu="pDtTerm">
                    <label class="col-3 form-label" mu-for="dtTerm">Termín</label>
                    <div class="col-9">
                        <input type="date" mu-bind="dtTerm|dateToInputD" class="form-control" />
                    </div>
                </div>
                <div class="row form-group" mu="pAttaches">
                    <label class="col-3 form-label">Příloha</label>
                    <div class="col-9">
                        <div mu="attachNew:MultiUpload"></div>
                        <div mu="attachList:AttachList"></div>
                    </div> 
                </div>
    
                <div class="buttons">
                    <span class="btn btn-default" mu="bSave">Uložit změny</span>
                    <span class="btn btn-primary" mu="bCreateTicket">Vytvořit položku</span>
                    <span class="btn btn-primary" mu="bCreateRepeating">Vytvořit řadu</span>
                    <span class="btn btn-primary" mu="bDone">Dokončit</span>
                    <span class="btn btn-primary" mu="bReopen">Znovu otevřít</span>
                </div>
            </div>
        `);
    }

    afterIndex() {
        this.updateForm();
        this.ui.pAttaches.append(this.muNamedWidget.attachList.ui.pPreview);
    }

    repeating_changeType() {
        this.updateForm();
    }

    private updateForm() {
        const rt = this.muNamedWidget.repeating.type;
        this.muVisible((rt === "none") || this.itemType === "ticket", [ "pAttaches", "pDtTerm" ]);
        this.muNamedWidget.repeating.hideNone = this.itemType !== "new";
        const repeatingEditable = this.itemType !== "ticket";
        this.muVisible(repeatingEditable, [ "repeating", "!repeatingInfo" ]);
        // this.ui.repeatingInfo.innerText = DateRepeating.getTextInfo(this.item.repeating);
        this.muVisible(this.itemType !== "new", 'bSave');
        this.muVisible(this.itemType === "new" && rt === "none", 'bCreateTicket');
        this.muVisible(this.itemType === "new" && rt !== "none", 'bCreateRepeating');
        // @ts-ignore
        this.muVisible(this.itemType === "ticket" && this.item.state === "new", 'bDone');
        // @ts-ignore
        this.muVisible(this.itemType === "ticket" && this.item.state === "done", 'bReopen');
        this.ui.modalTitle.innerText = this.itemType === "new"
            ? (rt === "none" ? "Nové todo" : "Nová řada")
            : "Upravit " + (this.itemType === "ticket" ? "todo" : "řadu");
    }

    async bSave_click() {
        await this.trySave();
    }

    async bCreateTicket_click() {
        await this.trySave();
    }

    async bCreateRepeating_click() {
        await this.trySave();
    }

    async bDone_click() {
        await this.trySave('close');
    }

    async bReopen_click() {
        await this.trySave('reopen');
    }

    private async trySave(stateActionCode: string|null = null) {
        const data = this.muFetchData();
        const dataR = {
            ...data,
            ...data.repeating,
        };
        data.stateActionCode = stateActionCode;

        if (this.validateForm()) {
            if (this.itemType === "new") {
                if (this.muNamedWidget.repeating.type === "none") {
                    this.item = await this.ticketsCl.saveTodoTicket(data, null);
                    this.itemType = "ticket";
                } else {
                    this.item = await this.ticketsCl.saveCalItemRepeating(dataR, null);
                    this.itemType = "cir";
                }
            } else {
                if (this.itemType === "ticket") {
                    this.item = await this.ticketsCl.saveTodoTicket(data, this.item!.id);
                } else {
                    this.item = await this.ticketsCl.saveCalItemRepeating(dataR, this.item!.id);
                }
            }
            flashInfo("Uloženo" + (stateActionCode ? " a změněn stav" : ""));
            if (this.itemType === "ticket" && this.muNamedWidget.attachNew.getAllFiles().length > 0) {
                var res = await this.muNamedWidget.attachNew.sendToBackend((ctx, send) => {
                    ctx.url = this.uploadUrl + "?metadata=" + encodeURIComponent(JSON.stringify({
                        ticketId: this.item!.id,
                        fileName: ctx.file.name,
                        contentType: ctx.file.type,
                        size: ctx.file.size,
                    }));
                    send();
                });
            }
            this.muDispatchEvent('saved');
        } else {
            flashError("Nejprve opravte chyby");
        }
    }

    private validateForm(): boolean {
        const data = this.muFetchData();
        const errors = new ErrorMarkerErrors();
        if (this.itemType !== "ticket")
            errors.merge(this.muNamedWidget.repeating.checkForm() || [], "repeating")
        if (!data.name)
            errors.add("name", "Zadejte název");

        this.errorMarker.markErrors(errors);

        return errors.isValid();
    }
}